import styled, { css } from 'styled-components'

type WrapperProps = {
  hasTestInput?: boolean
  topEyerBlock?: string
  topEyer?: string
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, hasTestInput, topEyer = '52px', topEyerBlock = '50px' }) => css`
    width: 100%;
    position: relative;

    input {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: ${theme.border.smallRadius};
      background: ${theme.colors.white};
      transition: 0.2s;

      &:disabled {
        cursor: not-allowed;
        color: ${theme.colors.gray};

        &:hover {
          border-color: ${theme.colors.lightGray};
          background: none;
          box-shadow: none;
        }
      }

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }

      ${hasTestInput &&
      css`
        height: 50px;
        background: ${theme.colors.xxlightGray};

        &::placeholder {
          color: ${theme.colors.black};
        }
      `}
    }

    > .icon-eyer-block {
      position: absolute;
      right: 14px;
      top: ${topEyerBlock};
      cursor: pointer;
    }

    > .icon-eyer {
      position: absolute;
      right: 14px;
      top: ${topEyer};
      cursor: pointer;
    }

    label {
      display: block;
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
      line-height: 1;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      color: ${theme.colors.white};
    }

    .error {
      color: ${theme.colors.red};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.bold};
      margin: 0px 0 4px 6px;
    }
  `}
`
